import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentResolveService } from '../environment-resolve/environment-resolve.service';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementsService {
  constructor(
    private http: HttpClient,
    private erService: EnvironmentResolveService
    ) {}

  public getAnnouncements(paging): Observable<any> {
    return this.http.post(this.erService.environmentERS.apiUrl, {
      application: 'Messaging',
      method: 'searchMessages',
      parameters: {
        filter: [
          {
            field: 'enabled',
            operator: 'equals',
            value: true
          },
          {
            field: 'expiry_date',
            operator: 'after',
            value: 'now'
          }
        ],
        paging
      }
    });
  }

  public getAnnouncement(id: string): Observable<any> {
    return this.http.post(this.erService.environmentERS.apiUrl, {
      application: 'Messaging',
      method: 'getMessage',
      parameters: {
        id
      }
    });
  }
}
